import db from "src/lib/dexie-db/db";
import { NodeType } from "src/modules/exam-preparation/graphql/common/types/node";
import { getSafeData } from "../../../db/utils";
export default async function getAncestorsDetails(userID, nodeID) {
    const node = await db.qnaNode.get(nodeID);
    if (!node) {
        throw new Error('Node not found');
    }
    const ancestors = await db.qnaNode
        .where('_id')
        .anyOf(node.ancestors)
        .toArray();
    const ancestorsMap = {};
    for (const ancestor of ancestors) {
        switch (ancestor.type) {
            case NodeType.COMMUNITY:
                ancestorsMap.community = getSafeData(ancestor);
                break;
            case NodeType.EXAM_LEVEL:
                ancestorsMap.examLevel = getSafeData(ancestor);
                break;
            case NodeType.WRITTEN_SUBJECT:
                ancestorsMap.writtenSubject = getSafeData(ancestor);
                break;
            case NodeType.ORALS_SUBJECT:
                ancestorsMap.oralsSubject = getSafeData(ancestor);
                break;
            case NodeType.WRITTEN_QP:
                ancestorsMap.writtenQP = getSafeData(ancestor);
                break;
            case NodeType.ORALS_QP:
                ancestorsMap.oralsQP = getSafeData(ancestor);
                break;
        }
    }
    return ancestorsMap;
}
